import { capitalize } from 'lodash'
import { observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

class QuestionSlide {
    id = uuidv4()

    kind = 'QuestionSlide'

    pageQuestionId

    chartType

    @observable comparisonSurveyIds

    @observable benchmarks

    ranking

    locked

    excludeNonNumeric

    comment

    hasBenchmarks

    constructor({
        pageQuestionId,
        chartType,
        benchmarks = [],
        comparisonSurveyIds = [],
        ranking,
    }) {
        this.pageQuestionId = pageQuestionId
        this.chartType = chartType
        this.ranking = ranking

        this.benchmarks = benchmarks
        this.hasBenchmarks = benchmarks.length > 0

        this.comparisonSurveyIds = comparisonSurveyIds
        this.hasComparisons = comparisonSurveyIds.length > 0
    }

    arrayOrUndefined = (arr) => {
        return Array.isArray(arr) && arr.length > 0
            ? arr.filter(({ checked }) => checked).map(({ value }) => capitalize(value))
            : undefined
    }

    toJSON() {
        return {
            kind: this.kind,
            pageQuestionId: this.pageQuestionId,
            chartType: this.chartType,
            comparisonSurveyIds: this.arrayOrUndefined(this.comparisonSurveyIds.slice()),
            benchmarks: this.arrayOrUndefined(this.benchmarks.slice()),
            ranking: this.ranking,
            locked: this.locked,
            excludeNonNumeric: this.excludeNonNumeric,
            comment: this.comment,
        }
    }
}

export default QuestionSlide
